import React from 'react';
import release1 from './releases/2023-09-01';
import LiqPageContainer from 'features/shared/UI/layout/LiqPageContainer';
import { Link } from 'react-router-dom';
import { Breadcrumbs } from '@mui/material';
import LiqExhibitTitleContainer from 'features/shared/UI/layout/LiqExhibitTitleContainer';
import LiqCard from 'features/shared/UI/layout/LiqCard';
import release2 from './releases/2025-03-31';

const releases = [release1, release2];

const PressReleaseList = () => {
    return (
        <LiqPageContainer>
            <div className="col-start-2 lg:col-start-3 col-end-12 lg:col-end-11">
                <Breadcrumbs className="col-start-2 lg:col-end-12 col-end-12" separator=">">
                    <Link to="/" className="hover:underline">
                        Lobby<b>IQ</b>
                    </Link>
                    <div>Press Releases</div>
                </Breadcrumbs>
            </div>
            <div className="lg:mt-8 mt-6 col-start-2 lg:col-start-3 col-end-12 lg:col-end-11">
                <LiqExhibitTitleContainer title="Press Releases" subtitle="" />
                <hr className="h-0.5 my-6 bg-slate-100 rounded" />
                <div className="flex flex-col gap-4">
                    {releases.map((release) => (
                        <LiqCard>
                            <Link
                                to={`/press-releases/${release.date}/${release.idx}`}
                                className="text-blue-400 font-medium hover:underline"
                            >
                                {release.title}
                            </Link>
                            <p className="text-slate-600 italic">Released {release.date}</p>
                        </LiqCard>
                    ))}
                </div>
            </div>
        </LiqPageContainer>
    );
};

export { PressReleaseList, releases };
